import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {getCurrentUser} from "@aws-amplify/auth";

export const signInGuard: CanActivateFn = async () => {
  const router = inject(Router);
  return getCurrentUser().then((user) => {
    router.navigate(['organisation']);
    return false;
  }).catch((e) => {
    return true;
  })
};
